import { ca } from '@cian/analytics';
import { useSelector } from 'react-redux';
import { selectMyHomeId } from '../../selectors/page';

export function useTracking() {
  const myHomeId = useSelector(selectMyHomeId);

  const trackServiceClick = (id: number, prelandingId?: number | null) => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'MyHome',
      action: 'Click_sopr',
      label: `ShelfService_${id}`,
      page: {
        extra: {
          MyHomeId: myHomeId,
          prelandingId,
        },
      },
    });
  };

  const trackOtherServicesVisible = () => {
    ca('teaser', {
      product: {
        name: 'other_services_show',
      },
    });
  };

  return {
    trackServiceClick,
    trackOtherServicesVisible,
  };
}
